export const SIGN_OUT_EVENT = 'SIGN_OUT_EVENT';
